import { render, staticRenderFns } from "./ResourceUsers.vue?vue&type=template&id=7abf6fd6&scoped=true&"
import script from "./ResourceUsers.vue?vue&type=script&lang=js&"
export * from "./ResourceUsers.vue?vue&type=script&lang=js&"
import style0 from "./ResourceUsers.vue?vue&type=style&index=0&id=7abf6fd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7abf6fd6",
  null
  
)

export default component.exports